<template>
    <div style="padding-top: 65px;height: 100vh">

        <el-row style="height: 100vh">
            <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8" class="border"  style="background-color:rgb(230,230,219);z-index: 888;">


                <el-carousel class="carousel">
                    <el-carousel-item v-for="item in list" :key="item">
                        <img :src="item.url" alt="" style="width: 100%">
                    </el-carousel-item>
                </el-carousel>



            </el-col>
            <el-col :xs="24" :sm="24" :md="16" :lg="16" :xl="16" class="border" style="padding: 20px;overflow: scroll">
                <el-form ref="form" :model="form"
                         :rules="rules">

                    <!--                    基础数据-->
                    <div>
                        <el-row>
                            <el-col :xs="12" :sm="12" :md="8" :lg="8" :xl="8">
                                <el-form-item label="A" prop="a">
                                    <el-input   type="number" v-model.number="form.a" disabled="disabled" :placeholder="placeholders[0]"/>
                                </el-form-item>
                            </el-col>
                            <el-col :xs="12" :sm="12" :md="8" :lg="8" :xl="8">
                                <el-form-item label="B" prop="b">
                                    <el-input  type="number" v-model.number="form.b" disabled="disabled" :placeholder="placeholders[0]" />
                                </el-form-item>
                            </el-col>
                            <el-col :xs="12" :sm="12" :md="8" :lg="8" :xl="8">
                                <el-form-item label="C" prop="c">
                                    <el-input  type="number" v-model.number="form.c" disabled="disabled" :placeholder="placeholders[0]" />
                                </el-form-item>
                            </el-col>

                            <el-col :xs="12" :sm="12" :md="8" :lg="8" :xl="8">
                                <el-form-item label="D" prop="d">
                                    <el-input  type="number" v-model.number="form.d" disabled="disabled" :placeholder="placeholders[0]" />
                                </el-form-item>
                            </el-col>
                            <el-col :xs="12" :sm="12" :md="8" :lg="8" :xl="8">
                                <el-form-item label="E" prop="e">
                                    <el-input  type="number" v-model.number="form.e" disabled="disabled" :placeholder="placeholders[0]" />
                                </el-form-item>
                            </el-col>
                            <el-col :xs="12" :sm="12" :md="8" :lg="8" :xl="8">
                                <el-form-item label="F" prop="f">
                                    <el-input  type="number" v-model.number="form.f" disabled="disabled" :placeholder="placeholders[0]" />
                                </el-form-item>
                            </el-col>

                            <el-col :xs="12" :sm="12" :md="8" :lg="8" :xl="8">
                                <el-form-item label="R1" prop="g">
                                    <el-input  type="number" v-model.number="form.g" :placeholder="placeholders[0]" />
                                </el-form-item>
                            </el-col>
                            <el-col :xs="12" :sm="12" :md="8" :lg="8" :xl="8">
                                <el-form-item label="R2" prop="h">
                                    <el-input  type="number"  v-model.number="form.h" :placeholder="placeholders[0]" />
                                </el-form-item>
                            </el-col>
                            <el-col :xs="12" :sm="12" :md="8" :lg="8" :xl="8">
                                <el-form-item label="R3" prop="jj">
                                    <el-input  type="number"  v-model.number="form.jj" :placeholder="placeholders[0]" />
                                </el-form-item>
                            </el-col>




                        </el-row>
                    </div>
                    <!--                    公差选择-->

                    <el-form-item :label="labels[0]">
                        <el-select v-model="form.ee" :placeholder="placeholders[1]">
                            <el-option :label="labels[1]" :value="0"></el-option>
                            <el-option :label="labels[2]" :value="1"></el-option>
                            <el-option :label="labels[3]" :value="2"></el-option>
                        </el-select>
                    </el-form-item>

                    <!--                    公差-->
                    <div v-if="gongcha">
                        <el-row>
                            <el-col :span="8">
                                <el-form-item label="A+"  prop="k"
                                >
                                    <el-input  type="number"  v-model.number="form.k" :placeholder="placeholders[2]" />
                                </el-form-item>
                            </el-col>
                            <el-col :span="8" :offset="4">
                                <el-form-item label="A-" prop="l"
                                >
                                    <el-input  type="number"  v-model.number="form.l" :placeholder="placeholders[3]"  />
                                </el-form-item>
                            </el-col>

                            <el-col :span="8">
                                <el-form-item label="B+" prop="m"
                                >
                                    <el-input  type="number"  v-model.number="form.m" :placeholder="placeholders[2]"  />
                                </el-form-item>
                            </el-col>
                            <el-col :span="8" :offset="4">
                                <el-form-item label="B-" prop="n"
                                >
                                    <el-input  type="number"  v-model.number="form.n" :placeholder="placeholders[3]"  />
                                </el-form-item>
                            </el-col>

                            <el-col :span="8">
                                <el-form-item label="C+" prop="o"
                                >
                                    <el-input  type="number"  v-model.number="form.o" :placeholder="placeholders[2]"  />
                                </el-form-item>
                            </el-col>
                            <el-col :span="8" :offset="4">
                                <el-form-item label="C-" prop="p"
                                >
                                    <el-input  type="number"  v-model.number="form.p" :placeholder="placeholders[3]"  />
                                </el-form-item>
                            </el-col>

                            <el-col :span="8">
                                <el-form-item label="D+" prop="q"
                                >
                                    <el-input  type="number"  v-model.number="form.q" :placeholder="placeholders[2]"  />
                                </el-form-item>
                            </el-col>
                            <el-col :span="8" :offset="4">
                                <el-form-item label="D-" prop="r"
                                >
                                    <el-input  type="number"  v-model.number="form.r" :placeholder="placeholders[3]"  />
                                </el-form-item>
                            </el-col>

                            <el-col :span="8">
                                <el-form-item label="E+" prop="s"
                                >
                                    <el-input  type="number"  v-model.number="form.s" :placeholder="placeholders[2]"  />
                                </el-form-item>
                            </el-col>
                            <el-col :span="8" :offset="4">
                                <el-form-item label="E-" prop="t"
                                >
                                    <el-input  type="number"  v-model.number="form.t" :placeholder="placeholders[3]"  />
                                </el-form-item>
                            </el-col>

                            <el-col :span="8">
                                <el-form-item label="F+" prop="u"
                                >
                                    <el-input  type="number"  v-model.number="form.u" :placeholder="placeholders[2]"  />
                                </el-form-item>
                            </el-col>
                            <el-col :span="8" :offset="4">
                                <el-form-item label="F-" prop="v"
                                >
                                    <el-input  type="number"  v-model.number="form.v" :placeholder="placeholders[3]"  />
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>
                    <!--                    气隙始-->
                    <el-form-item :label="labels[4]">
                        <el-select v-model="form.gg" :placeholder="placeholders[4]">
                            <el-option :label="labels[5]" :value="0"></el-option>
                            <el-option :label="labels[6]" :value="1"></el-option>

                        </el-select>
                    </el-form-item>


                    <el-row v-if="qi">
                        <el-col :span="12" >
                            <div class="max">
                                <el-form-item :label="labels[7]" prop="hh">
                                    <el-input  type="number"  v-model.number="form.hh" :placeholder="placeholders[5]"  />
                                </el-form-item>
                            </div>
                        </el-col>

                    </el-row>
                    <!--                    气隙末-->

                    <!--                    推拔倒角始-->
                    <el-form-item :label="labels[8]">
                        <el-select v-model="form.ii" :placeholder="placeholders[6]">
                            <el-option :label="labels[9]" :value="0"></el-option>
                            <el-option :label="labels[10]" :value="1"></el-option>

                        </el-select>
                    </el-form-item>
                    <el-row v-if="tuiba">
                        <el-col :span="12" >
                            <div class="max">
                                <el-form-item :label="labels[11]" prop="i">
                                    <el-input  type="number"  v-model.number="form.i" :placeholder="placeholders[7]"  />
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="12" >
                            <div class="max">
                                <el-form-item :label="labels[12]" prop="j">
                                    <el-input  type="number"  v-model.number="form.j" :placeholder="placeholders[8]"  />
                                </el-form-item>
                            </div>
                        </el-col>

                    </el-row>
                    <!--                    推拔倒角末-->

                    <!--                    槽始-->
                    <el-form-item :label="labels[13]">
                        <el-select v-model="form.cao" :placeholder="placeholders[9]">
                            <el-option :label="labels[14]" :value="0"></el-option>
                            <el-option :label="labels[15]" :value="1"></el-option>

                        </el-select>
                    </el-form-item>
                    <el-row v-if="cao">
                        <el-col :span="12" >
                            <el-form-item :label="labels[16]" prop="ll">
                                <el-input  type="number"  v-model.number="form.ll" :placeholder="placeholders[10]"  />
                            </el-form-item>
                        </el-col>
                        <el-col :span="12" >
                            <el-form-item :label="labels[17]" prop="kk">
                                <el-input  type="number"  v-model.number="form.kk" :placeholder="placeholders[11]"  />
                            </el-form-item>
                        </el-col>

                    </el-row>
                    <!--                    槽末-->
                    <div>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item :label="labels[18]" prop="x">
                                    <el-input  v-model.trim="form.x" :placeholder="placeholders[12]"  />
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item :label="labels[19]" prop="y">
                                    <el-input  v-model.trim="form.y" :placeholder="placeholders[13]"  />
                                </el-form-item>
                            </el-col>

                            <el-col :span="12">
                                <el-form-item :label="labels[20]" prop="z">
                                    <el-input  v-model.trim="form.z" :placeholder="placeholders[14]"  />
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item :label="labels[21]" prop="aa">
                                    <el-input  v-model.trim="form.aa" :placeholder="placeholders[15]"  />
                                </el-form-item>
                            </el-col>

                            <el-col :span="12">

                                <el-form-item

                                        :label="labels[22]"
                                        prop="bb"
                                        :rules="[{ required: true, message: 'Bitte geben Sie eine E-Mail-Adresse ein', trigger: 'blur' },{ type: 'email', message: 'Bitte geben Sie die korrekte E-Mail-Adresse ein', trigger: ['blur', 'change'] }]"
                                >
                                    <el-input  v-model.trim="form.bb" :placeholder="placeholders[16]" />
                                </el-form-item>
                            </el-col>

                        </el-row>

                    </div>

                    <el-form-item>
                        <el-button type="primary" @click="onSubmit" :loading=loading>提交数据</el-button>
                        <el-button type="danger" @click="link" :loading=loading>返回</el-button>

                    </el-form-item>
                </el-form>
            </el-col>
        </el-row>
    </div>
</template>
<script>
    import request from "@/utils/request";

    export default {
        name: "UY",
        metaInfo: {
            title: '大功率铁氧体磁芯|大功率磁芯|软磁铁氧体磁芯|锰锌铁氧体磁芯|南京恒创磁电有限公司 - Powered by MeCMS', // set a title
            meta: [{
                // 设置meta信息
                name: '大功率铁氧体磁芯|大功率磁芯|软磁铁氧体磁芯|锰锌铁氧体磁芯|大尺寸磁芯|X光磁芯|高压变压器磁芯|微波铁氧体',
                content: '大功率磁芯,南京恒创磁电专业生产各种高品质大磁芯，大功率铁氧体磁芯，软磁铁氧体磁芯，锰锌铁氧体磁芯，大尺寸磁芯，X光磁芯，高压变压器磁芯，电话:18913981759'
            }]
        },
        data(){
            var check=(rule, value, callback) =>{
                if (value) {
                    let tip = "";
                    if (value* 1<=0){
                        tip = "Der Wert muss größer oder gleich 0 sein"
                    }

                    if (tip) {
                        callback(new Error(tip));
                    } else {
                        callback();
                    }
                } else {

                    let tip = "";

                    if (value * 1 === 0||value * 1<0) {
                        tip = "Der Wert muss größer oder gleich 0 sein"
                    }else{

                    }

                    if (tip) {
                        callback(new Error(tip));
                    } else {
                        callback();
                    }
                }

            }
            var check2=(rule, value, callback) =>{
                if (value) {
                    let tip = "";
                    if (value* 1<0){
                        tip = "Der Wert muss größer oder gleich 0 sein"
                    }

                    if (tip) {
                        callback(new Error(tip));
                    } else {
                        callback();
                    }
                } else {
                    callback();
                }

            }
            return{
                list:[{
                    url:require("../../../assets/UY1.png")
                },{
                    url:require("../../../assets/UY2.png")
                },{
                    url:require("../../../assets/UY3.png")
                },{
                    url:require("../../../assets/UY4.png")
                },],
                gongcha:false,
                qi:false,
                tuiba:false,
                cao:false,
                lists:[],
                loading:false,
                labels:["Toleranz", "No Tolerance", "Standard Tolerance", "Custom Tolerance", "Air Gap", "No Air Gap", "Custom Air Gap", "Air Gap Value (Single Body)",
                    "Push Pull Fase", "No Push Pull Fase", "Benutzerdefinierte Push Pull Fase", "Push Pull Fase Länge (T)", "Push Pull Fase Winkel (Z)", "Slot", "No Slot", "Custom", "Slot Breite (W)", "Nuttiefe (S)",
                    "Produkt", "Material", "Firma", "Kunde", "E-Mail"],
                placeholders:["Bitte Daten eingeben (Einheit: mm) "," Bitte Toleranz wählen "," Bitte wählen Sie, ob ein Luftspalt vorhanden ist "," Bitte geben Sie einen Luftspaltwert ein "," Bitte wählen Sie aus, ob es eine Push Pull Fase gibt ",
                    "Push Pull Fasenlänge (in mm)", "Push Pull Fasenwinkel (in Grad)",
                    "Bitte wählen Sie, ob es einen Schlitz gibt", "Schlitzbreite (in mm)", "Schlitztiefe (in mm)", "Produktname", "Materialname", "Firmenname", "Kundenname",
                    "Bitte geben Sie eine E-Mail-Adresse ein"],
                buttons:["Submit", "Return"],
                form: {
                    ee:0,
                    gg:0,
                    cao:0,
                    ii:0,
                    language:1,
                    g:0,
                    h:0,
                    jj:0,
                    y:"H40"

                },
                rules:{
                    a:[
                        { required: true, message: 'Diese Daten sind obligatorisch', trigger: 'blur' },

                        // {type: 'number', message: '数据A必须为数字值'},
                        {validator: check,trigger: 'blur'}

                    ],
                    b:[
                        { required: true, message: 'Diese Daten sind obligatorisch', trigger: 'blur' },
                        // {type: 'number', message: '数据B必须为数字值'},
                        {validator: check,trigger: 'blur'}],
                    c:[
                        { required: true, message: 'Diese Daten sind obligatorisch', trigger: 'blur' },
                        // {type: 'number', message: '数据C必须为数字值'},
                        {validator: check,trigger: 'blur'}

                    ],
                    d:[
                        { required: true, message: 'Diese Daten sind obligatorisch', trigger: 'blur' },
                        // {type: 'number', message: '数据D必须为数字值'},
                        {validator: check,trigger: 'blur'}
                    ],
                    e:[
                        { required: true, message: 'Diese Daten sind obligatorisch', trigger: 'blur' },
                        // {type: 'number', message: '数据E必须为数字值'},
                        {validator: check,trigger: 'blur'}
                    ],
                    f:[
                        { required: true, message: 'Diese Daten sind obligatorisch', trigger: 'blur' },
                        // {type: 'number', message: '数据F必须为数字值'},
                        {validator: check,trigger: 'blur'}
                    ],
                    g:[
                        { required: true, message: 'Diese Daten sind obligatorisch', trigger: 'blur' },
                        // {type: 'number', message: '圆角1必须为数字值'},
                        {validator: check2,trigger: 'blur'}
                    ],
                    h:[
                        { required: true, message: 'Diese Daten sind obligatorisch', trigger: 'blur' },
                        // {type: 'number', message: '圆角2必须为数字值'},
                        {validator: check2,trigger: 'blur'}
                    ],
                    jj:[
                        { required: true, message: 'Diese Daten sind obligatorisch', trigger: 'blur' },
                        // {type: 'number', message: '圆角3必须为数字值'},
                        {validator: check2,trigger: 'blur'}
                    ],
                    x:[
                        { required: true, message: 'Diese Daten sind obligatorisch', trigger: 'blur' },

                    ],
                    y:[
                        { required: true, message: 'Diese Daten sind obligatorisch', trigger: 'blur' },

                    ],
                    z:[
                        { required: true, message: 'Diese Daten sind obligatorisch', trigger: 'blur' },

                    ],
                    aa:[
                        { required: true, message: 'Diese Daten sind obligatorisch', trigger: 'blur' },

                    ],
                    //    气隙
                    hh:[
                        { required: true, message: 'Luftspalt ist ein erforderlicher Wert, füllen Sie bitte 0 aus, wenn es keinen Luftspalt gibt', trigger: 'blur' },
                        {validator: function (rule, value, callback) {

                                if (value) {
                                    let tip = "";
                                    if (value* 1<0){
                                        tip = "Der Luftspaltwert darf nicht negativ sein"
                                    }

                                    if (tip) {
                                        callback(new Error(tip));
                                    } else {
                                        callback();
                                    }
                                }else{
                                    callback();
                                }


                            },trigger: 'blur'}
                    ],
                    //推拔倒角
                    i:[
                        { type: 'number', message: 'Bitte geben Sie den richtigen Wert ein', trigger: 'blur'},
                        {validator:check2,trigger: 'blur'}
                    ],
                    j:[
                        { type: 'number', message: 'Bitte geben Sie den richtigen Wert ein', trigger: 'blur'},
                        {validator:check2,trigger: 'blur'}
                    ],
                    k:[
                        { required: true, message: 'Toleranz ist ein geforderter Wert, füllen Sie bitte 0 aus, wenn es keine Toleranz gibt', trigger: 'blur' },

                    ],
                    l:[
                        { required: true, message: 'Toleranz ist ein geforderter Wert, füllen Sie bitte 0 aus, wenn es keine Toleranz gibt', trigger: 'blur' },

                    ],
                    m:[
                        { required: true, message: 'Toleranz ist ein geforderter Wert, füllen Sie bitte 0 aus, wenn es keine Toleranz gibt', trigger: 'blur' },

                    ],
                    n:[
                        { required: true, message: 'Toleranz ist ein geforderter Wert, füllen Sie bitte 0 aus, wenn es keine Toleranz gibt', trigger: 'blur' },

                    ],
                    o:[
                        { required: true, message: 'Toleranz ist ein geforderter Wert, füllen Sie bitte 0 aus, wenn es keine Toleranz gibt', trigger: 'blur' },

                    ],
                    p:[
                        { required: true, message: 'Toleranz ist ein geforderter Wert, füllen Sie bitte 0 aus, wenn es keine Toleranz gibt', trigger: 'blur' },

                    ],
                    q:[
                        { required: true, message: 'Toleranz ist ein geforderter Wert, füllen Sie bitte 0 aus, wenn es keine Toleranz gibt', trigger: 'blur' },

                    ],
                    r:[
                        { required: true, message: 'Toleranz ist ein geforderter Wert, füllen Sie bitte 0 aus, wenn es keine Toleranz gibt', trigger: 'blur' },

                    ],
                    s:[
                        { required: true, message: 'Toleranz ist ein geforderter Wert, füllen Sie bitte 0 aus, wenn es keine Toleranz gibt', trigger: 'blur' },

                    ],
                    t:[
                        { required: true, message: 'Toleranz ist ein geforderter Wert, füllen Sie bitte 0 aus, wenn es keine Toleranz gibt', trigger: 'blur' },

                    ],
                    u:[
                        { required: true, message: 'Toleranz ist ein geforderter Wert, füllen Sie bitte 0 aus, wenn es keine Toleranz gibt', trigger: 'blur' },

                    ],
                    v:[
                        { required: true, message: 'Toleranz ist ein geforderter Wert, füllen Sie bitte 0 aus, wenn es keine Toleranz gibt', trigger: 'blur' },

                    ],
                    //槽深槽宽
                    ll:[
                        { required: true, message: "Nuttiefe ist ein geforderter Wert. Wenn keine Slot-Tiefe vorhanden ist, füllen Sie bitte 0 aus oder wählen Sie 'Kein Slot'", trigger: 'blur' },
                        {validator:check2,trigger: 'blur'}
                    ],
                    kk:[
                        { required: true, message: "Nutbreite ist ein geforderter Wert. Wenn keine Schlitzbreite vorhanden ist, füllen Sie bitte 0 aus oder wählen Sie \"Kein Schlitz\"", trigger: 'blur' },
                        {validator:check2,trigger: 'blur'}
                    ],

                }

            }
        },
        watch:{
            form:{//深度监听，可监听到对象、数组的变化
                handler(val){
                    if(val.ee!=2){
                        this.gongcha=false
                    }else{
                        this.gongcha=true
                    }

                    if(val.gg==0){
                        this.qi=false
                    }else{
                        this.qi=true
                    }
                    if(val.ii==0){
                        this.tuiba=false
                    }else{
                        this.tuiba=true
                    }
                    if(val.cao==0){
                        this.cao=false
                    }else{
                        this.cao=true
                    }

                },
                deep:true //true 深度监听
            }


        }
        ,methods:{
            onSubmit(){

                this.$refs['form'].validate((valid) => {
                    if (valid){

                        // if (this.form.c>=this.form.b||this.form.c>=this.form.a||this.form.b>=this.form.a){
                        //     this.$message({
                        //         type:"error",
                        //         message:"C值不能大于A、B值，B值不能大于A值"
                        //     })
                        // }
                        this.form.zz = "127.0.0.1"
                        this.loading=true
                        request.post("http://www.magdraw.com/api/charting/addUY",this.form).then(res =>{


                            if (res.code=='0'){
                                this.loading=false
                                this.$message({
                                    type:"success",
                                    message:"Erfolg"
                                })

                                // this.load() //刷新表格
                                // this.dialogVisible=false //关闭弹窗
                            }else{
                                this.loading=false
                                this.$message({
                                    type:"error",
                                    message:res.msg
                                })
                            }

                        })
                    }else{

                    }

                })
            }
            ,replace: function (input) {
                let that=this;
                if (input.indexOf("±") != -1) {
                    that.sizeData=[];
                    that.sizeData.push(input.replace(/\s*/g, "").replaceAll("min", "").replaceAll("MIN", "").replaceAll("MAX", "").replaceAll("\\(", "").replaceAll("\\)", "").split("±")[0],
                        input.replace(/\s*/g, "").replaceAll("min", "").replaceAll("MIN", "").replaceAll("MAX", "").replaceAll("\\(", "").replaceAll("\\)", "").split("±")[1],
                        input.replace(/\s*/g, "").replaceAll("min", "").replaceAll("MIN", "").replaceAll("MAX", "").replaceAll("\\(", "").replaceAll("\\)", "").split("±")[1])
                    return that.sizeData;
                } else if (input.indexOf("+") != -1) {


                    if (input.indexOf("-")!=-1){


                        that.sizeData=[];
                        that.sizeData.push(input.replace(/\s*/g, "").replaceAll("min", "").replaceAll("MIN", "").replaceAll("MAX", "").replaceAll("\\(", "").replaceAll("\\)", "").split("+")[0].split("-")[0],
                            input.replace(/\s*/g, "").replaceAll("min", "").replaceAll("MIN", "").replaceAll("MAX", "").replaceAll("\\(", "").replaceAll("\\)", "").split("-")[1].split("+")[1],
                            input.replace(/\s*/g, "").replaceAll("min", "").replaceAll("MIN", "").replaceAll("MAX", "").replaceAll("\\(", "").replaceAll("\\)", "").split("-")[1].split("+")[0])

                    }else {

                        that.sizeData=[];
                        that.sizeData.push(input.replace(/\s*/g, "").replaceAll("min", "").replaceAll("MIN", "").replaceAll("MAX", "").replaceAll("\\(", "").replaceAll("\\)", "").split("+")[0].split("-")[0],
                            input.replace(/\s*/g, "").replaceAll("min", "").replaceAll("MIN", "").replaceAll("MAX", "").replaceAll("\\(", "").replaceAll("\\)", "").split("+")[1],
                            0)



                    }


                    return that.sizeData
                } else if (input.indexOf("-") != -1) {

                    that.sizeData=[];
                    if (input.indexOf("+")!=-1) {
                        that.sizeData.push(input.replace(/\s*/g, "").replaceAll("min", "").replaceAll("MIN", "").replaceAll("MAX", "").replaceAll("\\(", "").replaceAll("\\)", "").split("-")[0].split("+")[0],
                            input.replace(/\s*/g, "").replaceAll("min", "").replaceAll("MIN", "").replaceAll("MAX", "").replaceAll("\\(", "").replaceAll("\\)", "").split("-")[1].split("+")[1],
                            input.replace(/\s*/g, "").replaceAll("min", "").replaceAll("MIN", "").replaceAll("MAX", "").replaceAll("\\(", "").replaceAll("\\)", "").split("-")[1].split("+")[0])
                    }else{
                        that.sizeData.push(input.replace(/\s*/g, "").replaceAll("min", "").replaceAll("MIN", "").replaceAll("MAX", "").replaceAll("\\(", "").replaceAll("\\)", "").split("-")[0].split("+")[0],
                            0,
                            input.replace(/\s*/g, "").replaceAll("min", "").replaceAll("MIN", "").replaceAll("MAX", "").replaceAll("\\(", "").replaceAll("\\)", "").split("-")[1].split("+")[0])

                    }
                    return that.sizeData
                } else {
                    that.sizeData=[];
                    if (input.indexOf("MAX") != -1||input.indexOf("max") != -1){
                        that.sizeData.push(input.replace(/\s*/g, "").replaceAll("min", "").replaceAll("MIN", "").replaceAll("MAX", "").replaceAll("\\(", "").replaceAll("\\)", ""),
                            0,0)
                    }else if (input.indexOf("MIN") != -1||input.indexOf("min") != -1){
                        that.sizeData.push(input.replace(/\s*/g, "").replaceAll("min", "").replaceAll("MIN", "").replaceAll("MAX", "").replaceAll("\\(", "").replaceAll("\\)", ""),
                            0,0)
                    }else {
                        that.sizeData.push(input.replace(/\s*/g, "").replaceAll("min", "").replaceAll("MIN", "").replaceAll("MAX", "").replaceAll("\\(", "").replaceAll("\\)", ""),
                            0,0)
                    }


                    return that.sizeData

                }
            },
            link(){
                this.$router.go(-1)
            }
        }
        ,mounted(){
            let that=this;
            this.sn=this.$route.query.sn
            request.get("/product/selectOne/"+this.sn).then(res =>{

                var obj2=JSON.parse(res.data.defined)
                obj2.name=res.data.name

                that.form.x=obj2.name
                let sizeA=that.replace(obj2.A)
                let sizeB=that.replace(obj2.B)
                let sizeC=that.replace(obj2.C)
                let sizeD=that.replace(obj2.D)
                let sizeE=that.replace(obj2.E)
                let sizeF=that.replace(obj2.F)
                that.form.a=sizeA[0]
                that.form.k=sizeA[1]
                that.form.l=sizeA[2]
                that.form.b=sizeB[0]
                that.form.m=sizeB[1]
                that.form.n=sizeB[2]
                that.form.c=sizeC[0]
                that.form.o=sizeC[1]
                that.form.p=sizeC[2]
                that.form.d=sizeD[0]
                that.form.q=sizeD[1]
                that.form.r=sizeD[2]
                that.form.e=sizeE[0]
                that.form.s=sizeE[1]
                that.form.t=sizeE[2]
                that.form.f=sizeF[0]
                that.form.u=sizeF[1]
                that.form.v=sizeF[2]


              if (that.form.a<40){
                that.form.g=0.5
                that.form.h=0.2
                that.form.jj=0.2
                that.form.i=(that.form.f-that.form.e)/2
                that.form.j=3





              }
              else if (that.form.a>=40&&that.form.a<55){
                that.form.g=1
                that.form.h=0.2
                that.form.jj=0.2
                that.form.i=(that.form.f-that.form.e)/2
                that.form.j=3



              }
              else {
                that.form.g=2
                that.form.h=0.5
                that.form.jj=0.5
                that.form.i=(that.form.f-that.form.e)/2
                that.form.j=3



              }
            }).catch((res)=>{
            })

        }
    }
</script>

<style lang="less" scoped>
    i:hover{
        cursor: pointer;
        color: #db261d;
    }
    /*.border{*/

    /*    margin-top: 60px;*/
    /*    height: calc(100vh - 120px);*/
    /*}*/

    .el-input{
        width: 90%;
    }
    div::-webkit-scrollbar {
        display: none;
    }
    /deep/
    input::-webkit-inner-spin-button {
        -webkit-appearance: none !important;
    }
    .max .el-form-item__label{
        line-height: 20px !important;
    }
    .carousel{

        margin-top: 20vh;
        text-align: center;
        img{
            height: 100%;
        }
    }

    @media screen and (max-width:768px){
        .carousel{

            margin: 0;
            padding: 0;

        }
    }
</style>